module.exports = __webpack_public_path__ + "img/3_title.51d6c645.png";